export default "__VITE_ASSET__C8W6Jy4Z__"